// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/vercel/path0/docs/guide/conventional-routing.md?type=frontmatter';
import { demoIndex as dmi0 } from '/vercel/path0/docs/guide/conventional-routing.md?type=demo-index';
import { frontmatter as fm1, toc as t1 } from '/vercel/path0/docs/guide/project-structure.md?type=frontmatter';
import { demoIndex as dmi1 } from '/vercel/path0/docs/guide/project-structure.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/vercel/path0/docs/theme/global-component.md?type=frontmatter';
import { demoIndex as dmi2 } from '/vercel/path0/docs/theme/global-component.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/vercel/path0/docs/guide/auto-api-table.md?type=frontmatter';
import { demoIndex as dmi3 } from '/vercel/path0/docs/guide/auto-api-table.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/vercel/path0/docs/guide/mobile-library.md?type=frontmatter';
import { demoIndex as dmi4 } from '/vercel/path0/docs/guide/mobile-library.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/vercel/path0/docs/guide/vue-api-table.md?type=frontmatter';
import { demoIndex as dmi5 } from '/vercel/path0/docs/guide/vue-api-table.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/vercel/path0/docs/guide/page-config.md?type=frontmatter';
import { demoIndex as dmi6 } from '/vercel/path0/docs/guide/page-config.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/vercel/path0/docs/guide/initialize.md?type=frontmatter';
import { demoIndex as dmi7 } from '/vercel/path0/docs/guide/initialize.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/vercel/path0/docs/guide/write-demo.md?type=frontmatter';
import { demoIndex as dmi8 } from '/vercel/path0/docs/guide/write-demo.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/vercel/path0/docs/plugin/techstack.md?type=frontmatter';
import { demoIndex as dmi9 } from '/vercel/path0/docs/plugin/techstack.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/vercel/path0/docs/config/markdown.md?type=frontmatter';
import { demoIndex as dmi10 } from '/vercel/path0/docs/config/markdown.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/vercel/path0/docs/guide/upgrading.md?type=frontmatter';
import { demoIndex as dmi11 } from '/vercel/path0/docs/guide/upgrading.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/vercel/path0/docs/config/runtime.md?type=frontmatter';
import { demoIndex as dmi12 } from '/vercel/path0/docs/config/runtime.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/vercel/path0/docs/guide/commands.md?type=frontmatter';
import { demoIndex as dmi13 } from '/vercel/path0/docs/guide/commands.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/vercel/path0/docs/guide/markdown.md?type=frontmatter';
import { demoIndex as dmi14 } from '/vercel/path0/docs/guide/markdown.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/vercel/path0/docs/guide/page-tab.md?type=frontmatter';
import { demoIndex as dmi15 } from '/vercel/path0/docs/guide/page-tab.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/vercel/path0/docs/plugin/market.md?type=frontmatter';
import { demoIndex as dmi16 } from '/vercel/path0/docs/plugin/market.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/vercel/path0/docs/theme/default.md?type=frontmatter';
import { demoIndex as dmi17 } from '/vercel/path0/docs/theme/default.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/vercel/path0/docs/config/index.md?type=frontmatter';
import { demoIndex as dmi18 } from '/vercel/path0/docs/config/index.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/vercel/path0/docs/plugin/index.md?type=frontmatter';
import { demoIndex as dmi19 } from '/vercel/path0/docs/plugin/index.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/vercel/path0/docs/theme/market.md?type=frontmatter';
import { demoIndex as dmi20 } from '/vercel/path0/docs/theme/market.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/vercel/path0/docs/theme/mobile.md?type=frontmatter';
import { demoIndex as dmi21 } from '/vercel/path0/docs/theme/mobile.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/vercel/path0/docs/config/demo.md?type=frontmatter';
import { demoIndex as dmi22 } from '/vercel/path0/docs/config/demo.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/vercel/path0/docs/guide/index.md?type=frontmatter';
import { demoIndex as dmi23 } from '/vercel/path0/docs/guide/index.md?type=demo-index';
import { frontmatter as fm24, toc as t24 } from '/vercel/path0/docs/theme/index.md?type=frontmatter';
import { demoIndex as dmi24 } from '/vercel/path0/docs/theme/index.md?type=demo-index';
import { frontmatter as fm25, toc as t25 } from '/vercel/path0/docs/config/env.md?type=frontmatter';
import { demoIndex as dmi25 } from '/vercel/path0/docs/config/env.md?type=demo-index';
import { frontmatter as fm26, toc as t26 } from '/vercel/path0/docs/guide/i18n.md?type=frontmatter';
import { demoIndex as dmi26 } from '/vercel/path0/docs/guide/i18n.md?type=demo-index';
import { frontmatter as fm27, toc as t27 } from '/vercel/path0/docs/plugin/api.md?type=frontmatter';
import { demoIndex as dmi27 } from '/vercel/path0/docs/plugin/api.md?type=demo-index';
import { frontmatter as fm28, toc as t28 } from '/vercel/path0/docs/plugin/new.md?type=frontmatter';
import { demoIndex as dmi28 } from '/vercel/path0/docs/plugin/new.md?type=demo-index';
import { frontmatter as fm29, toc as t29 } from '/vercel/path0/docs/guide/faq.md?type=frontmatter';
import { demoIndex as dmi29 } from '/vercel/path0/docs/guide/faq.md?type=demo-index';
import { frontmatter as fm30, toc as t30 } from '/vercel/path0/docs/guide/vue.md?type=frontmatter';
import { demoIndex as dmi30 } from '/vercel/path0/docs/guide/vue.md?type=demo-index';
import { frontmatter as fm31, toc as t31 } from '/vercel/path0/docs/theme/api.md?type=frontmatter';
import { demoIndex as dmi31 } from '/vercel/path0/docs/theme/api.md?type=demo-index';
import { frontmatter as fm32, toc as t32 } from '/vercel/path0/docs/index.md?type=frontmatter';
import { demoIndex as dmi32 } from '/vercel/path0/docs/index.md?type=demo-index';
import { frontmatter as fm33, toc as t33 } from '/vercel/path0/docs/guide/page-tab.$tab-example.md?type=frontmatter';
import { demoIndex as dmi33 } from '/vercel/path0/docs/guide/page-tab.$tab-example.md?type=demo-index';

export const filesMeta = {
  'docs/guide/conventional-routing': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/conventional-routing.md?type=text'),
  },
  'docs/guide/project-structure': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/project-structure.md?type=text'),
  },
  'docs/theme/global-component': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/theme/global-component.md?type=text'),
  },
  'docs/guide/auto-api-table': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/auto-api-table.md?type=text'),
  },
  'docs/guide/mobile-library': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/mobile-library.md?type=text'),
  },
  'docs/guide/vue-api-table': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/vue-api-table.md?type=text'),
  },
  'docs/guide/page-config': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/page-config.md?type=text'),
  },
  'docs/guide/initialize': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/initialize.md?type=text'),
  },
  'docs/guide/write-demo': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/write-demo.md?type=text'),
  },
  'docs/plugin/techstack': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/plugin/techstack.md?type=text'),
  },
  'docs/config/markdown': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/config/markdown.md?type=text'),
  },
  'docs/guide/upgrading': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/upgrading.md?type=text'),
  },
  'docs/config/runtime': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/config/runtime.md?type=text'),
  },
  'docs/guide/commands': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/commands.md?type=text'),
  },
  'docs/guide/markdown': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/markdown.md?type=text'),
  },
  'docs/guide/page-tab': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    tabs: ["docs/guide/page-tab.$tab-example"],
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/page-tab.md?type=text'),
  },
  'docs/plugin/market': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/plugin/market.md?type=text'),
  },
  'docs/theme/default': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/theme/default.md?type=text'),
  },
  'docs/config/index': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/config/index.md?type=text'),
  },
  'docs/plugin/index': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/plugin/index.md?type=text'),
  },
  'docs/theme/market': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/theme/market.md?type=text'),
  },
  'docs/theme/mobile': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/theme/mobile.md?type=text'),
  },
  'docs/config/demo': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/config/demo.md?type=text'),
  },
  'docs/guide/index': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/index.md?type=text'),
  },
  'docs/theme/index': {
    frontmatter: fm24,
    toc: t24,
    demoIndex: dmi24,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/theme/index.md?type=text'),
  },
  'docs/config/env': {
    frontmatter: fm25,
    toc: t25,
    demoIndex: dmi25,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/config/env.md?type=text'),
  },
  'docs/guide/i18n': {
    frontmatter: fm26,
    toc: t26,
    demoIndex: dmi26,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/i18n.md?type=text'),
  },
  'docs/plugin/api': {
    frontmatter: fm27,
    toc: t27,
    demoIndex: dmi27,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/plugin/api.md?type=text'),
  },
  'docs/plugin/new': {
    frontmatter: fm28,
    toc: t28,
    demoIndex: dmi28,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/plugin/new.md?type=text'),
  },
  'docs/guide/faq': {
    frontmatter: fm29,
    toc: t29,
    demoIndex: dmi29,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/faq.md?type=text'),
  },
  'docs/guide/vue': {
    frontmatter: fm30,
    toc: t30,
    demoIndex: dmi30,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/vue.md?type=text'),
  },
  'docs/theme/api': {
    frontmatter: fm31,
    toc: t31,
    demoIndex: dmi31,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/theme/api.md?type=text'),
  },
  'docs/index': {
    frontmatter: fm32,
    toc: t32,
    demoIndex: dmi32,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/index.md?type=text'),
  },
  'docs/guide/page-tab.$tab-example': {
    frontmatter: fm33,
    toc: t33,
    demoIndex: dmi33,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/guide/page-tab.$tab-example.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
